import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ChevronRight } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DescriptionModal } from "../DescriptionModal/DescriptionModal";
export function OptionsCard({ label, icon: Icon, to, disabled = false, category, onModalOpenChange, renderModal = true, }) {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
        setIsModalOpen(true);
        onModalOpenChange?.(true, category, to);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        onModalOpenChange?.(false, category, to);
    };
    const handleClick = () => {
        if (!category) {
            navigate(to);
            return;
        }
        openModal();
    };
    return (_jsxs(_Fragment, { children: [_jsxs("button", { id: category
                    ? `btn-registrar-${category.toLowerCase().replaceAll("_", "-")}`
                    : `btn-menu-${to.replace(/^\//, "").replaceAll("/", "-")}`, "data-testid": "menu-option-button", disabled: disabled, onClick: handleClick, className: "flex w-full justify-between items-center p-4 bg-[#F9FCFF]\n      disabled:text-gray-300 hover:bg-gray-200 disabled:hover:bg-[#F9FCFF]\n      transition-all duration-300 ease-in-out text-[#262626] font-semibold\n      border-[#BFBFBF] border rounded-lg", children: [_jsxs("div", { className: "flex gap-3 items-center min-w-0 text-left", children: [_jsx(Icon, { className: "shrink-0" }), _jsx("span", { className: "truncate", children: label })] }), _jsx(ChevronRight, { className: "shrink-0" })] }), category && renderModal && (_jsx(DescriptionModal, { isOpen: isModalOpen, onClose: closeModal, category: category, to: to }))] }));
}
